/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const MediaItemJsonApiModel = {
  id: "",
  manager: {
    jsonApi: "hasOne",
    type: "managers",
  },
  opportunity: {
    jsonApi: "hasOne",
    type: "opportunities",
  },
  author: "",
  title: "",
  description: "",
  url: "",
  "cover-img-url": "",
  "sort-order": "",
};
